import { create } from 'zustand'

import type {
  ImpersonationActiveResponse,
  ImpersonationAdminUser,
  ImpersonationTargetUser,
} from '@repo/shared'

const STORAGE_KEY = 'impersonation_session_id'

function readStoredId(): string | null {
  if (typeof window === 'undefined') return null
  try {
    return window.sessionStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

function writeStoredId(id: string | null) {
  if (typeof window === 'undefined') return
  try {
    if (id) window.sessionStorage.setItem(STORAGE_KEY, id)
    else window.sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore — incognito + storage disabled
  }
}

interface ImpersonationState {
  sessionId: string | null
  expiresAt: string | null
  targetUser: ImpersonationTargetUser | null
  admin: ImpersonationAdminUser | null
  setSession: (session: ImpersonationActiveResponse) => void
  setSessionId: (sessionId: string | null) => void
  clear: () => void
}

export const useImpersonationStore = create<ImpersonationState>((set) => ({
  sessionId: readStoredId(),
  expiresAt: null,
  targetUser: null,
  admin: null,
  setSession: (session) => {
    writeStoredId(session.sessionId)
    set({
      sessionId: session.sessionId,
      expiresAt: session.expiresAt,
      targetUser: session.targetUser,
      admin: session.admin,
    })
  },
  setSessionId: (sessionId) => {
    writeStoredId(sessionId)
    set({ sessionId })
  },
  clear: () => {
    writeStoredId(null)
    set({ sessionId: null, expiresAt: null, targetUser: null, admin: null })
  },
}))
